import Swiper, { Navigation, Pagination, EffectFade } from "swiper";

export default () => {

	const imgSliders = document.querySelectorAll('.js-card-img-slider');
	if (!imgSliders.length) return;

	imgSliders.forEach(sliderEl => {

		const cardWrapper = sliderEl.closest('.js-card');

		const slider = new Swiper(sliderEl, {
			modules: [ Navigation, Pagination, EffectFade ],
			speed: 200,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
		});

		cardWrapper.addEventListener('mouseenter', () => {
			slider.slideNext();
		});

		cardWrapper.addEventListener('mouseleave', () => {
			slider.slideTo(0);
		});

	})

}
